import http from 'hub-http/clients/apiClient';
export const submitInteraction = upgradeKey => http.post(`/upgrade-management-service/v1/interactions/${upgradeKey}`);